import React from 'react';
import { components as Core, ICONS, useTranslation } from '../../../../core';
import { css, colors, fonts, spacing, StyleSheet } from '../../../../../styles';

/**
 * Displays the integration state and blocking reason.
 *
 * @param {object} props
 * @param {object} props.integration
 */
export const IntegrationStatus = ({ integration }) => {
    const { t } = useTranslation();
    const isBlocked = integration.isBlocked || integration.blockedMarketSync;
    let status = {
        color: colors.green,
        icon: ICONS.unlock,
        text: t('integrations.isUnlockedTooltip')
    };

    if (integration.isBlocked) {
        status = {
            color: colors.red,
            icon: ICONS.lock,
            text: t('integrations.isLockedTooltip')
        };
    } else if (integration.blockedMarketSync) {
        status = {
            color: colors.red,
            icon: ICONS.lock,
            text: t('integrations.isMarketLockedTooltip')
        };
    } else if (integration.needRelogin) {
        status = {
            color: colors.red,
            icon: ICONS.warning,
            text: t('integrations.needReloginTooltip')
        };
    }

    return (
        <div className={css(styles.statusContainer)}>
            <div className={css(styles.statusSummary)}>
                <p className={css(styles.statusLabel)}>{t('integrations.status')}</p>
                <Core.Icon type={status.icon} color={status.color} size={spacing.s3} />
                <p className={css(styles.statusText)}>{status.text}</p>
            </div>
            {isBlocked ? (
                <div className={css(styles.errorContainer)}>
                    <p>{t('integrations.blockingReason')}</p>
                    {integration.failMessage ? <p>{integration.failMessage}</p> : null}
                </div>
            ) : null}
        </div>
    );
};

const styles = StyleSheet.create({
    statusContainer: {
        padding: spacing.s2,
        marginBottom: spacing.s3,
        border: `1px solid ${colors.greyLight}`,
        borderRadius: spacing.s1,
        backgroundColor: colors.white
    },
    statusSummary: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing.s1
    },
    statusLabel: {
        ...fonts.smBold,
        margin: 0
    },
    statusText: {
        ...fonts.smNormal,
        color: colors.blackOpacity,
        margin: 0
    },
    errorContainer: {
        ...fonts.xsBold,
        lineHeight: fonts.smNormal.lineHeight,
        color: colors.red,
        marginTop: spacing.s1,
        paddingLeft: spacing.s4,
        '& p': {
            margin: 0
        }
    }
});
